import { HOME_PRODUCT_KEYS } from './secondaryNavBody.js'

/** @typedef {{ headerTitle: string, highlighted?: boolean, sections: { type: string, label?: string }[] }} HomeProductNavConfig */

/** @type {Record<string, HomeProductNavConfig>} */
export const HOME_PRODUCT_NAV = {
  [HOME_PRODUCT_KEYS.CHAT]: {
    headerTitle: 'Chat',
    highlighted: true,
    // Documents moved into the thread header, where the list is scoped to the
    // open conversation rather than the whole library.
    sections: [{ type: 'homeNavRail' }],
  },
  [HOME_PRODUCT_KEYS.VOICE]: {
    headerTitle: 'Voice',
    highlighted: true,
    sections: [{ type: 'homeVoicePrimaryActions' }, { type: 'homeVoiceNavRail' }],
  },
  [HOME_PRODUCT_KEYS.CODE]: {
    headerTitle: 'Code',
    highlighted: true,
    sections: [{ type: 'homeCodePrimaryActions' }, { type: 'homeCodeNavRail' }],
  },
}

/** @param {string} homeProduct */
export function getHomeProductNav(homeProduct) {
  return HOME_PRODUCT_NAV[homeProduct] ?? HOME_PRODUCT_NAV[HOME_PRODUCT_KEYS.CHAT]
}
